import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class NotificationService extends ResourceService {
  constructor(private authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.notifications.listUrl, ServiceConfig.notifications.detailUrl);
  }

  count(): Observable<any> {
    return this.authorizedService.get(ServiceConfig.notifications.countUrl).map(data => data.json());
  }

  readAll(): Observable<any> {
    return this.authorizedService.get(ServiceConfig.notifications.readAllUrl).map(data => data.json());
  }
}



// WEBPACK FOOTER //
// ./src/services/notification.service.ts